export default "__VITE_ASSET__DYDVS1co__"